import styled, { keyframes } from 'styled-components';

const easeIn = (t: number) => t * t;
const getCircumference = (size: number, thickness: number) => 2 * Math.PI * ((size - thickness) / 2);

const circleAnimated = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0px;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;

const circularRotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div<{ size: number }>`
  display: inline-block;
  line-height: 1;
  width: ${props => props.size / 10}rem;
  height: ${props => props.size / 10}rem;
  animation: ${circularRotate} 1.4s linear infinite;
  color: ${props => props.color};
`;

export const SVG = styled.svg`
  display: block;
  color: ${props => props.color};
`;

export const Circle = styled.circle<{ size: number; thickness: number; value?: number }>`
  stroke: currentColor;
  animation: ${circleAnimated} 1.4s ease-in-out infinite;
  stroke-dasharray: 8rem, 20rem;
  stroke-dashoffset: ${props =>
    (easeIn((100 - (props.value ? props.value : 0)) / 100) * getCircumference(props.size, props.thickness)).toFixed(
      3
    )}px;
  stroke-width: ${props => props.thickness};
`;
